import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { App } from "@/App";
import { ToastProvider } from "@/components/ui/Toast";
import "@/styles/globals.css";

/**
 * Toasts for successful / failed mutations are emitted directly from
 * `apiPost/apiPut/apiDelete` (see lib/api.ts) so they fire even when
 * a page calls `await apiPost(...)` outside of `useMutation`. That's
 * why no MutationCache hook is configured here.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);
